<script setup lang="ts">
import useTranslate from "@/hooks/useTranslate/useTranslate";
import { useTIWStore } from "@/stores/tiw/tiw";
import { I_WIDGET_STEPS } from "@/stores/tiw/tiw.types";

interface Props {
    stepToReturn?: I_WIDGET_STEPS;
    onBack?: () => void | Promise<void>;
}
const { stepToReturn, onBack, ...rest } = defineProps<Props>();

const TIWStore = useTIWStore();

function onClick() {
    if (onBack) {
        onBack();
        return;
    }
    if (stepToReturn) {
        TIWStore.switchStep(stepToReturn);
        return;
    }

    TIWStore.goToPrevStep();
}
</script>

<template>
    <button class="tiw__step__chooseRangeDiscount__back" @click="onClick" v-bind="rest">
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M6.47852 3.33325L2.00047 7.99992L6.47852 12.6666"
                stroke="#808D9A"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <line
                x1="0.75"
                y1="-0.75"
                x2="11.072"
                y2="-0.75"
                transform="matrix(1 0 0 -1 2.17773 7.35449)"
                stroke="#808D9A"
                stroke-width="1.5"
                stroke-linecap="round"
            />
        </svg>
        <p>{{ useTranslate("tiw__back") }}</p>
    </button>
</template>
